import React, { useContext } from "react";
import { ProduitInterface } from "dataProvider/Produit";
import { IntlContext } from "context";
import Tooltip from "ui/Form/Element/Tooltip";

export interface AllegationsProps {
    produit: ProduitInterface | any;
}
const Allegations: React.FC<AllegationsProps> = ({ produit }) => {
    const intl = useContext(IntlContext);

    if (!(produit?.produit_allegations || []).length) {
        return null;
    }

    // Ordre :
    // - Allegation nutritionnelle
    // - Allegation de santé
    // - Autres allégations
    const allegationTypeIds: string[] = ["6", "15"];
    const othersId: string = "others";
    let allegationTypeLabels: HashMap<{ label?: string; tooltip?: string; order?: number }> = {
        "6": {
            label: intl.formatMessage("produit.fiche.label.allegation_sante"),
            tooltip: intl.formatMessage("produit.fiche.tooltip.allegation_sante"),
        },
        "15": {
            label: intl.formatMessage("produit.fiche.label.allegation_nutritionnelle"),
            tooltip: intl.formatMessage("produit.fiche.tooltip.allegation_nutritionnelle"),
        },
        others: {
            label: intl.formatMessage("produit.fiche.label.autre_allegation"),
            tooltip: intl.formatMessage("produit.fiche.tooltip.autre_allegation"),
        },
    };

    const allegations = (produit?.produit_allegations || []).reduce(
        (memo: HashMap<string[]>, allegation: HashMap<any>) => {
            let typeId = "" + allegation?.id_allegation_type;
            typeId = allegationTypeIds.includes(typeId) ? typeId : othersId;

            if (!memo[typeId]) {
                memo[typeId] = [];
            }

            if (allegation?.allegation_libel && !memo[typeId].includes(allegation?.allegation_libel)) {
                memo[typeId].push(allegation?.allegation_libel);
            }

            if (allegation?.allegation_texte && !memo[typeId].includes(allegation?.allegation_texte)) {
                memo[typeId].push(allegation?.allegation_texte);
            }

            return memo;
        },
        {}
    );

    const renderAllegations = (allegations: HashMap<string[]>) => {
        let allegationsOrdered = Object.entries(allegations).sort((a: any, b: any) => {
            if (a[0] === othersId) {
                return 100;
            }
            return b[0] - a[0];
        });

        return allegationsOrdered.map((values: any, index: number) => {
            const memo: any[] = [];
            const allegTypeLabel = allegationTypeLabels[values[0]]?.label;
            const allegTypeTooltip = allegationTypeLabels[values[0]]?.tooltip;

            const allegationValues = allegations[values[0]].map((allegationValue: string, index: number) => {
                return <p key={index}>{allegationValue}</p>;
            });

            memo.push(
                <div key={index} className="product-others-informations">
                    <p className="font-bold">
                        {allegTypeLabel}
                        {Boolean(allegTypeTooltip?.length) && <Tooltip value={allegTypeTooltip} />}
                    </p>

                    {allegationValues}
                </div>
            );
            return memo;
        });
    };

    return (
        <div className="product-informations__block">
            <h2 className="information__title">{intl.formatMessage("produit.fiche.label.allegations")}</h2>
            {renderAllegations(allegations)}
        </div>
    );
};

export default Allegations;
